import browser from"bowser";var PREFIX=browser.webkit||browser.blink?"-webkit-":browser.gecko?"-moz-":"";export default{DEFAULTS:{},CURSOR:{GRABBING:"".concat(PREFIX,"grabbing"),GRAB:"".concat(PREFIX,"grab"),POINTER:"pointer"}};
//# sourceMappingURL=config.js.map


//////////////////
// WEBPACK FOOTER
// ./~/react-map-gl/dist/esm/config.js
// module id = 886
// module chunks = 0